(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luxora-product-shelf"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-lxs-scroll]');
    if (!button) return;
    const shelf = button.closest('.lxs-shelf');
    const track = shelf && shelf.querySelector('.lxs-shelf__track');
    const card = track && track.querySelector('.lxs-card');
    if (!track || !card) return;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const direction = button.dataset.lxsScroll === 'previous' ? -1 : 1;
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollBy({left: direction * (card.getBoundingClientRect().width + gap), behavior: reducedMotion ? 'auto' : 'smooth'});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
